import axios, {AxiosResponse} from "axios";
import {LocalStorageKey, LocalStorageManagement} from "@/libs/LocalStorage";
import {BASE_API, responseHandler} from "@/api/auth";
import {message} from "antd";

export interface TBaseResponse<T extends unknown> {
    data: T,
    enMessage: string,
    message: string,
    status: number
}

export const defaultHeaders = () => {
    return {
        'authorization': new LocalStorageManagement(LocalStorageKey.token).value
    }
}

export interface TTextToVideoResponse {
    task_id: string,
    create_time: string,
}

export async function textToVideoApi(options: {
    prompt: string
}): Promise<AxiosResponse<TBaseResponse<TTextToVideoResponse>>> {
    const {prompt} = options;
    if (!prompt) {
        message.error('请输入内容');
        return Promise.reject('请输入内容');
    }
    return new Promise((resolve, reject) => {
        axios.post<TBaseResponse<TTextToVideoResponse>>(BASE_API + "/sora/text-to-video", {
            prompt
        }, {
            params: {
                ...defaultHeaders()
            }
        }).then(res => {
            responseHandler(res, resolve, reject);
        }).catch((e: any) => {
            reject(e);
        });
    });
}

export enum TTaskType {
    textToVideo = 'text to video',
    imageToVideo = 'image to video',
    textToImage = 'text to image',
    order = 'order',
}

export interface TTextToVideoTask {
    type: TTaskType.textToVideo;
    user_id: number;
    sora_task_id: string;
    mj_center_task_id: string;
    go_mj_task_id: string;
    stability_task_id: string;
    img_url: string;
    prompt: string;
    create_time: string;
    status: 'waiting to imgList' | 'loading to imgList' | 'waiting to img' | 'loading to img' | 'waiting to video' | 'loading to video' | 'finished' | 'failed';
    // 支付状态：未扣款、预扣款（任务进行中但还未完成）、已扣款
    // 如果任务失败，不需要退款，预扣款是为了防止用户余额不足，只是一个标记
    pay_status: 'no pay' | 'pre pay' | 'paid';
}

export function sleep(time: number) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve('');
        }, time);
    });
}

export async function getVideoStatusApi(options: {
    task_id: string
}): Promise<AxiosResponse<TBaseResponse<TTextToVideoTask>>> {
    const {task_id} = options;
    if (!task_id) {
        message.error('请输入内容');
        return Promise.reject('请输入内容');
    }
    return new Promise((resolve, reject) => {
        axios.get<TBaseResponse<TTextToVideoTask>>(BASE_API + "/sora/task", {
            params: {
                id: task_id,
                ...defaultHeaders()
            }
        }).then(res => {
            responseHandler(res, resolve, reject);
        }).catch((e: any) => {
            reject(e);
        });
    });
}


export async function textToVideoApiControl(options: {
    prompt: string,
}) {
    const {prompt} = options;
    if (!prompt) {
        message.error('请输入内容');
        return Promise.reject('请输入内容');
    }
    return await textToVideoApi({prompt}).then((res) => {
        return res.data;
    }).catch((e) => {
        throw e;
    })
}